import React from "react";
import { MdClear, MdCreate } from "react-icons/md";
import { IReportInfo } from "../../../api/types/reports/IReportInfo";
import { ReportAction } from "../../../api/types/reports/ReportAction";
import { ControlButtonStyled } from "../../../components/styled/ControlButton.styled";
import { ControlButtonContainerStyled } from "../../../components/styled/ControlButtonContainer.styled";
import { useAppDispatch } from "../../../store/hooks";
import { showAlert, showModal } from "../../../store/modals/modalsSlice";

interface Props {
  disabled: boolean;
  info: IReportInfo;
}

export const TicketGridRowControlButtons = ({ disabled, info }: Props) => {
  const dispatch = useAppDispatch();

  const edit = () => {
    dispatch(
      showModal({
        type: "edit",
        info,
        id: info.id,
        kind: "ticketGrid",
      }),
    );
  };

  const remove = () => {
    dispatch(
      showAlert({
        title: "Удалить билетную сетку?",
        message: `Билетная сетка "${info.name}" и все связанные данные будут удалены. Это действие нельзя будет отменить.`,
        id: info.id,
        actions: [
          { title: "Отмена", kind: "standard" },
          {
            title: "Удалить",
            kind: "danger",
            onPress: {
              action: ReportAction.deleteReport,
              scope: "ticketGrid",
              params: {
                action: ReportAction.deleteReport,
                id: info.id,
              },
            },
          },
        ],
      }),
    );
  };

  return (
    <ControlButtonContainerStyled inline>
      <ControlButtonStyled
        title={"Редактировать"}
        onClick={() => edit()}
        disabled={disabled}
      >
        <MdCreate />
      </ControlButtonStyled>
      <ControlButtonStyled
        variant={"danger"}
        title={"Удалить"}
        disabled={disabled}
        onClick={() => remove()}
      >
        <MdClear />
      </ControlButtonStyled>
    </ControlButtonContainerStyled>
  );
};
